"use client";

import { useEffect } from "react";

import { isChunkLoadError } from "@/lib/runtime/chunk-load-error";
import { reportNextjsError } from "@/lib/datadog/rum";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const isChunk = isChunkLoadError(error);

  useEffect(() => {
    reportNextjsError(error);
  }, [error]);

  if (isChunk) {
    return (
      <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 text-center">
        <p className="max-w-md text-sm text-muted-foreground">
          A new version of Inora was deployed. Refresh to load the latest files.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-full bg-foreground px-5 py-2 text-sm font-medium text-background"
        >
          Refresh page
        </button>
      </div>
    );
  }

  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <p className="text-sm text-muted-foreground">Something went wrong.</p>
      <button
        type="button"
        onClick={reset}
        className="rounded-full border border-border px-4 py-2 text-sm"
      >
        Try again
      </button>
    </div>
  );
}
